export const getMinutesFromDate = (date: string) => (Date.parse(date) - Date.now()) / 1_000 / 60;
